import { ZId, ZSidLabel } from "src/types";

const makeClassParentLabelBuilder = (parents: ZSidLabel[][]) => {
  const parentsReg = parents?.reduce(
    (acc, parent) => {
      const last = parent[parent.length - 1];
      if (!last) return acc;
      const newPath = parent.map(({ label }) => label).join("/");
      acc[last.id] = acc[last.id] ? `${acc[last.id]} | ${newPath}` : newPath;
      return acc;
    },
    {} as Record<ZId, string>,
  );

  return (id: ZId) => parentsReg[id];
};

export const makeClassParentsOptions = (parents: ZSidLabel[][]) => {
  const parentsValues =
    parents
      ?.map((parent) => parent[parent.length - 1])
      .filter((parent) => parent !== undefined)
      .map((parent) => parent.id) || [];
  const uniqueValues = Array.from(
    new Map(parentsValues.map((val) => [val, val])).values(),
  );
  const labelBuilder = makeClassParentLabelBuilder(parents);
  const parentsOptions: ZSidLabel[] = uniqueValues.map((id) => ({
    id: String(id),
    label: labelBuilder(id) ?? "-",
  }));

  return parentsOptions;
};
